import { useState } from 'react'

import { Center, Heading, Spinner } from '@chakra-ui/react'

import Page from '../components/page'
import Article from '../components/article'
import Background from '../components/background'

const ServerInfo = () => {
  const [isLoading /*, setLoading*/] = useState(false)
 const [data /*, setData*/] = useState({
  data: '<div class="panel-body">' +
        '<p></p>' +
         '<h4>STRIFE SERVER INFO:</h4>' +
        '🔘 HAVOC SERVER <br>' +
        '🔘 4 CLASS (BRAWLER/SWORDSMAN/ARCHER/SHAMAN) <br>' +
        '🔘 210 MAX LEVEL <br>' +
        '🔘 167 MAX SKILL <br>' +
        '🔘 +10 MAX UPGRADE <br>' +
        '🔘 CLASSIC RAN ONLINE GAMING <br>' +
        '🔘 PARTY LEVELING <br>' +
        '🔘 PURE HUNTING <br>' +
        '🔘 FARM BASED <br>' +
        '🔘 QUEST BASED <br>' +
        '🔘 VERY LOW EXP RATE 💯 <br>' +
        '🔘 VERY LOW DROP RATE 💯 <br>' +
        '🔘 CLUB WARS (SCHEDULE: TUESDAY/THURSDAY/SATURDAY)' +

        '<h4>STRIFE WEBSITE:</h4>' +
        '🌐 <a href="https://ranonlineph-official.com" target="_blank" rel="noopener noreferrer">' +
        'https://ranonlineph-official.com' +
        '</a><br><br>' +

        '<h4>HAVOC SERVER INFO:</h4>' +
        '🔘 HAVOC SERVER <br>' +
        '🔘 4 CLASS (BRAWLER/SWORDSMAN/ARCHER/SHAMAN) <br>' +
        '🔘 150 MAX LEVEL <br>' +
        '🔘 127 MAX SKILL <br>' +
        '🔘 +9 MAX UPGRADE <br>' +
        '🔘 CLASSIC RAN ONLINE GAMING <br>' +
        '🔘 PARTY LEVELING <br>' +
        '🔘 PURE HUNTING <br>' +
        '🔘 FARM BASED <br>' +
        '🔘 QUEST BASED <br>' +
        '🔘 VERY LOW EXP RATE 💯 <br>' +
        '🔘 VERY LOW DROP RATE 💯 <br>' +
        '🔘 CLUB WARS (SCHEDULE: MONDAY/WEDNESDAY/FRIDAY)' +
        '<h4>HAVOC WEBSITE:</h4>' +
        '🌐 <a href="https://havoc.ranonlineph-official.com" target="_blank" rel="noopener noreferrer">' +
        'https://havoc.ranonlineph-official.com' +
        '</a><br><br>' +

        '<h4>FEATURES:</h4>' +
        '🔘 CHARACTER PREVIEW <br>' +
        '🔘 CHARACTER SIMPLIFY <br>' +
        '🔘 IN-GAME REGISTRATION <br>' +
        '🔘 IN-GAME ITEM SHOP (DISABLED IN WEBSITE) <br>' +
        '🔘 HARDWARE BAN SYSTEM IMPLEMENTED <br><br>' +
        '<h4>MORE SERVERS TO BE ADDED IN THE FUTURE</h4>' +
        '<p></p>' +
        '</div>'
});


  const ServerInfoHeader = () => (
    <Heading variant="main" fontSize={[32]} fontWeight={800} mb={5}>
      SERVER INFO
    </Heading>
  )

  return (
    <>
      <Page
        title="Server Info"
        header={<ServerInfoHeader />}
        narrowProfile
        highProfile
      >
        {isLoading ? (
          <Center>
            <Spinner />
          </Center>
        ) : (
          <Article
            title={'RAN Online PH Server Info'}
            subtitle={'Server Info'}
            innerHTML={data.data}
          />
        )}
      </Page>

      <Background highProfile />
    </>
  )
}

export default ServerInfo
